import * as tslib_1 from "tslib";
/* I122 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Subfolders = /** @class */ (function (_super) {
    tslib_1.__extends(Subfolders, _super);
    function Subfolders() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Subfolders.prototype.render = function () {
        return (React.createElement(IconWrap, tslib_1.__assign({}, this.props),
            React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("defs", null,
                    React.createElement("path", { d: "M5,11 L19,11 L19,21 L5,21 L5,11 Z M7,13 L7,17 L17,17 L17,13 L7,13 Z M7,7 L17,7 L17,9 L7,9 L7,7 Z M9,3.9980587 L15,3.9980587 L15,5 L9,5 L9,3.9980587 Z", id: "path-1", stroke: "currentColor", fillRule: "evenodd" })),
                React.createElement("g", { id: "Icons-/-Sub-Folders---i122", fillRule: "evenodd" },
                    React.createElement("mask", { id: "mask-2" },
                        React.createElement("use", { xlinkHref: "#path-1" })),
                    React.createElement("use", { id: "Mask", xlinkHref: "#path-1" }),
                    React.createElement("g", { id: "\uD83C\uDFA8-Color", mask: "url(#mask-2)" },
                        React.createElement("rect", { width: "24", height: "24", transform: "translate(.333 .333)", id: "D01" }))))));
    };
    return Subfolders;
}(React.Component));
export { Subfolders };
export default Subfolders;
//# sourceMappingURL=Subfolders.js.map